export default __webpack_public_path__ + "static/media/bulletIcon.95d20a41.svg";